import { Injectable } from '@angular/core';
import { Urls } from '@core/config';
import { RestClientService } from '@smartera/core';
import { catchError, map, Observable, throwError as observableThrowError } from 'rxjs';
import { SmartyGptConversation, SmartyGptQuestion, SmartyGptResponse } from '../models/smarty-gpt';

@Injectable()
export class SmartyGptService {
	constructor(private restClientService: RestClientService) {}

	private get apiUrl(): string {
		return `${Urls.BASE_URL}/ai-data-analyze/ask`;
	}

	queryWithAssistantByIndexId(smartyGptQuestion: SmartyGptQuestion): Observable<SmartyGptConversation[]> {
		const url = `${this.apiUrl}/es-query-with-assistant-by-index-id`;
		return this.restClientService
			.post(url, JSON.stringify(smartyGptQuestion))
			.pipe(catchError((error: Error) => observableThrowError(error)))
			.pipe(map(this.prepareConversationForLoad));
	}

	loadConversationByIndexId(indexId: string): Observable<SmartyGptConversation[]> {
		const url = `${this.apiUrl}/load-conversation-by-index-id/${indexId}`;
		return this.restClientService
			.get(url)
			.pipe(catchError((error: Error) => observableThrowError(error)))
			.pipe(map(this.prepareConversationForLoad));
	}

	saveLogToHistoryByIndexId(indexId: string, conversation: SmartyGptConversation[]): Observable<void> {
		const url = `${this.apiUrl}/add-logs-to-thread-history-by-index-id/${indexId}`;
		conversation = this.prepareConversationForSave(conversation);
		return this.restClientService.post(url, JSON.stringify(conversation));
	}

	private prepareConversationForSave(conversation: SmartyGptConversation[]): SmartyGptConversation[] {
		return conversation.map((item) => {
			if (item.role === 'assistant') {
				item.content = JSON.stringify(item.content);
			}
			return item;
		});
	}

	private prepareConversationForLoad(conversation: SmartyGptConversation[]): SmartyGptConversation[] {
		return conversation.map((item) => {
			if (item.role === 'assistant') {
				item.content = <SmartyGptResponse>(
					JSON.parse((<string>item.content).replaceAll('```', '').replaceAll('json', ''))
				);
			}
			return item;
		});
	}

	clearConversationByIndexId(indexId: string): Observable<void> {
		const url = `${this.apiUrl}/clear-conversation-by-index-id/${indexId}`;
		return this.restClientService.delete(url).pipe(catchError((error: Error) => observableThrowError(error)));
	}
}
